import createReducer from '../utils/createReducer';
import hasPpsListingsActions from '../actions/hasPpsListings';

const initialState = {
    hasPpsListings: false,
    loaded: false
};

const actionHandlers = {
    [hasPpsListingsActions.GET_HAS_PPS_LISTINGS_SUCCESS](state, {payload}) {
        return {
            ...state,
            hasPpsListings: payload.hasPpsListings,
            loaded: true
        };
    },

    [hasPpsListingsActions.HAS_PPS_LISTINGS_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            errorKey: payload.errorKey,
            loaded: true
        };
    }
};

export default createReducer(actionHandlers, initialState);
